import { render, staticRenderFns } from "./Comingsoon_rami2.vue?vue&type=template&id=0bc8a9e0&scoped=true&"
import script from "./Comingsoon_rami2.vue?vue&type=script&lang=js&"
export * from "./Comingsoon_rami2.vue?vue&type=script&lang=js&"
import style0 from "./Comingsoon_rami2.vue?vue&type=style&index=0&id=0bc8a9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8a9e0",
  null
  
)

export default component.exports